import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {Helper} from '../../helpers/helper.service';
import {HttpClient, HttpParams} from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { Part, PartListResponse } from '../Models/Part';

@Injectable()
export class PartsService {
  constructor(private helper: Helper, private http: HttpClient) {}

  public getPart(gridData = new HttpParams(), params = {}, scope = 'backoffice') {
    return this.http.get<PartListResponse>(environment.apiUrl + '/' + scope + '/part/?' + gridData.toString())
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getPartItem(partId: number, scope = 'backoffice') {
    return this.http.get<Part>(environment.apiUrl + '/' + scope + '/part/' + partId)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public managePart(part: Part, isEdit: boolean, id: number = null) {
    if (isEdit) {
      return this.http.put(environment.apiUrl + '/backoffice/part/' + id + '/edit', part)
        .pipe(catchError(res => this.helper.catchError(res)));
    }
    return this.http.post(environment.apiUrl + '/backoffice/part/new', part)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public addStockToPart(payload: {stockAmount: number}, id: number = null) {
    return this.http.put(environment.apiUrl + '/backoffice/part/' + id + '/stock', payload)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public softDeletePart(id: number) {
    return this.http.delete(environment.apiUrl + '/backoffice/part/' + id + '/delete' )
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public reAdd(id: number) {
    return this.http.post(environment.apiUrl + '/backoffice/part/' + id + '/readd', {id: id})
      .pipe(catchError(res => this.helper.catchError(res)));
  }
}
